import { Flex, Grid } from "@eworkit/iris";
import React from "react";
import { useTranslation } from "react-i18next";

import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { EmptyText } from "@/components/EmptyText";
import { Text } from "@/components/Text";
import { IAddress } from "@/data/companies";
import { Group } from "@/eworkitComponents";

interface ICompanyAddressSectionProps extends IEditableSectionRenderProps {
  addresses?: IAddress[];
}

export const CompanyAddressPreview = ({ addresses }: ICompanyAddressSectionProps) => {
  const { t } = useTranslation("session");

  return (
    <Grid columns="1fr 1fr" gap="lg">
      {addresses &&
        addresses.length > 0 &&
        addresses.map((address, index) => (
          <Flex key={`${address?.type}-${index}`} flexDirection="column" gap="sm">
            <Group label={t("USERS.SETTINGS.COMPANY_CONTACT_DETAILS.FORM.ADDRESS.ADDRESS_LINE_1")} direction="column">
              <Text size="md" color="black">
                {address.addressLine1 ? address.addressLine1 : <EmptyText />}
              </Text>
            </Group>

            <Group label={t("USERS.SETTINGS.COMPANY_CONTACT_DETAILS.FORM.ADDRESS.ADDRESS_LINE_2")} direction="column">
              <Text size="md" color="black">
                {address.addressLine2 ? address.addressLine2 : <EmptyText />}
              </Text>
            </Group>

            <Group label={t("USERS.SETTINGS.COMPANY_CONTACT_DETAILS.FORM.ADDRESS.ZIP_CODE")} direction="column">
              <Text size="md" color="black">
                {address.zipCode ? address.zipCode : <EmptyText />}
              </Text>
            </Group>

            <Group label={t("USERS.SETTINGS.COMPANY_CONTACT_DETAILS.FORM.ADDRESS.STATE")} direction="column">
              <Text size="md" color="black">
                {address.state ? address.state : <EmptyText />}
              </Text>
            </Group>

            <Group label={t("USERS.SETTINGS.COMPANY_CONTACT_DETAILS.FORM.ADDRESS.CITY")} direction="column">
              <Text size="md" color="black">
                {address.city?.city ? address.city.city : <EmptyText />}
              </Text>
            </Group>

            <Group label={t("USERS.SETTINGS.COMPANY_CONTACT_DETAILS.FORM.ADDRESS.COUNTRY")} direction="column">
              <Text size="md" color="black">
                {address.city?.country ? address.city.country : <EmptyText />}
              </Text>
            </Group>
          </Flex>
        ))}
    </Grid>
  );
};
